import { TuiDay } from '@taiga-ui/cdk';
import { Maybe } from '@iss/libs/graphql';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Directive, inject, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

import { DateFormValidators } from '../validators';

const selector =
  '' +
  'tui-input-date[min][formControlName],' +
  'tui-input-date[min][formControl],' +
  'tui-input-date[min][ngModel],' +
  'tui-input-date[minDate][formControlName],' +
  'tui-input-date[minDate][formControl],' +
  'tui-input-date[minDate][ngModel]'
;

@Directive({
  selector,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinDateDirective,
      multi: true,
    },
    DatePipe,
  ],
  standalone: true,
})
export class MinDateDirective implements Validator {
  private readonly date = inject(DatePipe);

  @Input('min')
  public min: Maybe<TuiDay>;

  @Input('minDate')
  public minDate: Maybe<TuiDay>;

  public validate(control: AbstractControl): ValidationErrors | null {
    const minDate = this.min || this.minDate;
    const min = this.date.transform(minDate?.toLocalNativeDate(), 'yyyy-MM-dd');
    if (!min) return null;

    return DateFormValidators.minDate(min)(control);
  }
}
